// assets/a24-mobile-drawer.js
/* Mobile drawer and legacy drawer accordion behavior. */
(function () {
  'use strict';

  /* ---- Mobile Drawer ---- */
  var burger = document.getElementById('menuToggle') || document.getElementById('burger-btn');
  var drawer = document.getElementById('mobileDrawer') || document.getElementById('mobile-drawer');
  var drawerOverlay = document.getElementById('drawerOverlay') || document.getElementById('drawer-overlay');
  var drawerClose = document.getElementById('drawerClose') || document.getElementById('drawer-close');
  var html = document.documentElement;

  var scrollLockTop = 0;
  var isScrollLocked = false;
  var previousBodyStyles = null;
  var previousHtmlOverflow = '';

  function syncDrawerViewportHeight() {
    var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    if (!Number.isFinite(viewportHeight) || viewportHeight <= 0) return;
    html.style.setProperty('--a24-mobile-drawer-height', Math.round(viewportHeight) + 'px');
  }

  function lockBackgroundScroll() {
    if (isScrollLocked) return;

    scrollLockTop = window.pageYOffset || html.scrollTop || 0;
    previousBodyStyles = {
      overflow: document.body.style.overflow,
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width
    };
    previousHtmlOverflow = html.style.overflow;

    document.body.classList.add('drawer-open');
    html.classList.add('drawer-open');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = (-scrollLockTop) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    html.style.overflow = 'hidden';
    isScrollLocked = true;
  }

  function unlockBackgroundScroll() {
    if (!isScrollLocked) return;

    var restoreScrollTop = Math.abs(parseInt(document.body.style.top || '0', 10)) || scrollLockTop;

    document.body.classList.remove('drawer-open');
    html.classList.remove('drawer-open');

    if (previousBodyStyles) {
      document.body.style.overflow = previousBodyStyles.overflow;
      document.body.style.position = previousBodyStyles.position;
      document.body.style.top = previousBodyStyles.top;
      document.body.style.left = previousBodyStyles.left;
      document.body.style.right = previousBodyStyles.right;
      document.body.style.width = previousBodyStyles.width;
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
    }

    html.style.overflow = previousHtmlOverflow || '';
    isScrollLocked = false;
    window.scrollTo(0, restoreScrollTop);
  }

  function openDrawer() {
    if (!drawer) return;
    syncDrawerViewportHeight();
    drawer.classList.add('open');
    drawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('active');
    if (drawerOverlay) drawerOverlay.classList.add('is-active');
    lockBackgroundScroll();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('active');
    if (drawerOverlay) drawerOverlay.classList.remove('is-active');
    unlockBackgroundScroll();
  }

  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer && drawer.classList.contains('open')) {
      closeDrawer();
    }
  });

  window.addEventListener('resize', syncDrawerViewportHeight, { passive: true });
  window.addEventListener('orientationchange', syncDrawerViewportHeight, { passive: true });
  if (window.visualViewport && typeof window.visualViewport.addEventListener === 'function') {
    window.visualViewport.addEventListener('resize', syncDrawerViewportHeight, { passive: true });
  }
  syncDrawerViewportHeight();

  /* Mobile accordion */
  document.querySelectorAll('.drawer-accordion__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = this.nextElementSibling;
      var parent = this.parentElement;
      var isOpen = parent.classList.contains('is-open');
      document.querySelectorAll('.drawer-accordion__item.is-open').forEach(function (el) {
        el.classList.remove('is-open');
        var openPanel = el.querySelector('.drawer-accordion__content');
        if (openPanel) openPanel.style.maxHeight = null;
      });

      if (!isOpen && panel) {
        parent.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });
}());
